import React from 'react';
import PropTypes from 'prop-types';
import { DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import './FlightDateTimePicker.scss';


const FlightDateTimePicker = (props) => {
  const {
    onChange, value, format, disabled, disableFuture, disablePast,
    minDate, maxDate, label, onError, readOnly, showTodayButton,
    minutesStep, allowKeyboardControl,
  } = props;

  const pickerProps = {
    value,
    onChange,
    label,
    onError,
    readOnly,
    format,
    disabled,
    disableFuture,
    disablePast,
    showTodayButton,
    minutesStep,
    allowKeyboardControl,
  };
  if (minDate) {
    pickerProps.minDate = minDate;
  }
  if (maxDate) {
    pickerProps.maxDate = maxDate;
  }

  return (
    <div className="flight-datetime-picker">
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <DateTimePicker {...pickerProps} />
      </MuiPickersUtilsProvider>
    </div>
  );
};

FlightDateTimePicker.propTypes = {
  value: PropTypes.instanceOf(Date),
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  format: PropTypes.string,
  disabled: PropTypes.bool,
  disableFuture: PropTypes.bool,
  disablePast: PropTypes.bool,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  minDateMessage: PropTypes.string,
  maxDateMessage: PropTypes.string,
  invalidDateMessage: PropTypes.string,
  onError: PropTypes.func,
  readOnly: PropTypes.bool,
  showTodayButton: PropTypes.bool,
  minutesStep: PropTypes.number,
  allowKeyboardControl: PropTypes.bool,
};

FlightDateTimePicker.defaultProps = {
  value: null,
  label: '',
  format: 'yyyy-MM-dd hh:mm a',
  disabled: false,
  disableFuture: false,
  disablePast: false,
  minDate: null,
  maxDate: null,
  minDateMessage: 'Date should not be before minimal date',
  maxDateMessage: 'Date should not be after maximal date',
  invalidDateMessage: 'Invalid Date Format',
  onError: () => undefined,
  readOnly: false,
  showTodayButton: true,
  minutesStep: 5,
  allowKeyboardControl: true,
};

export default FlightDateTimePicker;
